import { useContext } from 'react';

import type { Partner } from 'src/modules/designStudio/helpers/Partner';
import { ModeContext } from 'src/modules/designStudio/providers';

const usePartner = (): Partner => {
  const { partner } = useContext(ModeContext);

  return partner;
};

export { usePartner };
